import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { formatDisplayValue } from '../../lib/styles/perttierNumber';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { unloadConveyorList } from '../../modules/conveyor/conveyorsSlice';
import { setOriginalConveyor } from '../../modules/conveyor/conveyorWriteSlice';

const PulleyList = ({ conveyors, loading, error, project, ownProject }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const language = useSelector((state) => state.language.language);
    const isJP = language === 'JP' ? true : false;
    const isEN = language === 'EN' ? true : false;
    const onEdit = (conveyor) => {
        // 클릭하면 Pulley 계산하는 창으로 이동하는....
        dispatch(unloadConveyorList());
        dispatch(setOriginalConveyor(conveyor));
        navigate('/write/pulley');
    };

    // 에러 발생시
    if (error) {
        return <PulleyListBlock>Unknown Error!!!</PulleyListBlock>
    }

    // 로딩 중이거나 아직 컨베이어가 없을 때
    if (loading || !conveyors) {
        return null;
    }

    return (
        <PulleyListBlock>
            <Content>
                <Caption>
                    <h1>Pulley List</h1>
                    <span>{isEN ? '(Unit: Pulley Dia/Bearing Inner Dia in mm, Quanityt in ())' : isJP ? '(単位：プーリ径／ベアリング内径 mm、カッコ内は数量)' : '(Unit: 풀리직경/베어링내경 mm, 괄호안은 수량)'}</span>
                </Caption>
                <Table>
                    <thead>
                        <tr>
                            <th className="title">BC ID.</th>
                            <th className="belt-width">Belt Width</th>
                            <th className="info-window">Drive</th>
                            <th className="info-window">Snub</th>
                            <th className="info-window">Bend</th>
                            <th className="info-window">Takeup</th>
                            <th className="info-window">Tail</th>
                            <th className="info-window">HTBend</th>
                            <th className="info-window">LTBend</th>
                            <th className="weight">Total<br/>(kg)</th>
                            <th className="btn-area"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {conveyors &&
                            conveyors.map((conveyor, index) => {
                                const { title, body: { pulleys }, } = conveyor;
                                // if (!pulleys || pulleys.length === 0) {
                                //     return [];
                                // }

                                /* pulleys를 indexArry에 따라 정렬하자. 입려할 때 순서가 바뀔수도 있다. */
                                // const indexArray = ['Drive', 'Snub', 'Bend', 'Takeup', 'Tail', 'HTBend', 'LTBend'];
                                // const sortedPulleys = [...pulleys].sort((a, b) => {
                                //     const indexA = indexArray.indexOf(a.application);
                                //     const indexB = indexArray.indexOf(b.application);
                                //     // 만약 indexArray에 없는 application이 있다면, 정렬 순서에서 마지막으로 배치
                                //     return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
                                // });

                                return (
                                    <tr key={index}>
                                        <td>{title}</td>
                                        {/* <td>{sortedPulleys[0]?.beltWidth}</td>
                                        {sortedPulleys.map((pulley) => (
                                            <td key={pulley.id}>
                                                {pulley.diaSelected}({pulley.numberOfPulley})
                                            </td>
                                        ))}
                                        {sortedPulleys.length < 6 && (
                                            <>
                                                <td></td>
                                                <td></td>
                                            </>
                                        )} */}
                                        {(!pulleys) && (
                                            <>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>
                                                    <ActionButton>
                                                        {
                                                            ownProject && (
                                                                <StyledButton onClick={() => onEdit(conveyor)}>
                                                                    Edit
                                                                </StyledButton>
                                                            )
                                                        }
                                                    </ActionButton>
                                                </td>
                                            </>
                                        )}
                                        {pulleys && (
                                            <>
                                                <td>{pulleys[0]?.beltWidth}</td>
                                                <td>
                                                    <div>{getText(pulleys, '1st Drive')}</div>
                                                    <div>{getText(pulleys, '2nd Drive')}</div>
                                                    <div>{getText(pulleys, '3rd Drive')}</div>
                                                </td>
                                                <td>
                                                    <div>{getText(pulleys, '1st Snub')}</div>
                                                    <div>{getText(pulleys, '2nd Snub')}</div>
                                                    <div>{getText(pulleys, '3rd Snub')}</div>
                                                </td>
                                                <td>{getText(pulleys, 'Bend')}</td>
                                                <td>{getText(pulleys, 'Takeup')}</td>
                                                <td>{getText(pulleys, 'Tail')}</td>
                                                <td>{getText(pulleys, 'HTBend')}</td>
                                                <td>{getText(pulleys, 'LTBend')}</td>
                                                <td>{formatDisplayValue(pulleyWeightTotal(pulleys))}</td>
                                                <td>
                                                    <ActionButton>
                                                        {
                                                            ownProject && (
                                                                <StyledButton onClick={() => onEdit(conveyor)}>
                                                                    Edit
                                                                </StyledButton>
                                                            )
                                                        }
                                                    </ActionButton>
                                                </td>
                                            </>
                                        )}
                                    </tr>
                                );
                            })}
                    </tbody>
                    {/* <tfoot>
                        <tr>
                            <td className="title">Total</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tfoot> */}
                </Table>
            </Content>
        </PulleyListBlock>
    );
};

export default PulleyList;

/* =================   Styles   ================== */
const PulleyListBlock = styled.div`
    display: flex;
    img {
        width: 100%;
    }
`;

const Content = styled.div`
    width: 100%;
    overflow-x: auto;
`;

const Caption = styled.div`
    display: flex;
    justify-content: space-between;
    h1 {
        font-size: 1.125rem;
        margin: 0;
        margin-bottom: 1rem;
    }
    span {
        font-size: 0.9rem;
    }
`;

const Table = styled.table`
    //overflow-x: auto;   // 테이블을 감싸는 요소에 적용해야 한다.

    width: 100%;
    border-collapse: collapse;
    font-size: 0.9rem;
    text-align: center;
    thead tr th {
        font-weight: 500;
        padding: 0.5rem 0.25rem;
        background: ${palette.gray[2]};
        border-bottom: 2px solid ${palette.gray[4]};
        // min-width: 120px;
    }
    tbody tr {
        &:nth-child(even) {
            background: ${palette.gray[2]};
        }
    }
    tbody tr td {
        height: 3rem;
        padding: 0.5rem 0.25rem;
    }
    tfoot {
        height: 3rem;
        background: ${palette.gray[2]};
        // text-align: right;
        font-weight: 500;
    }
    .title {
        text-align: center;
        min-width: 80px;
    }
    .belt-width {
        min-width: 100px;
    }
    .info-window {
        min-width: 120px;
    }
    .weight {
        min-width: 100px;
    }
    .btn-area {
        min-width: 70px;
    }
`;

const ActionButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    // margin-top: 1rem;
    // margin-bottom: 2rem;
`;

const StyledButton = styled.button`
    padding: 0.125rem 0.25rem;
    border-radius: 4px;
    border: none;
    background-color: ${palette.orange};
    color: white;
    font-size: 0.85rem;
    font-weight: 550;
    text-align: center;
    border: 1px solid transparent;
    &:hover {
        background-color: #fff;
        color: ${palette.orange};
        border: 1px solid ${palette.orange};
        cursor: pointer;
        transition: 0.3s;
    }
`;


export const getText = (pulleys, application) => {
    const obj = pulleys.find(pulley => pulley.application === application);
    if (!obj) {
        return '';
    }
    return `∅${obj.diaSelected}/∅${obj.brgDiaSelected*10} (${obj.numberOfPulley})`;
}

export const pulleyWeightTotal = (pulleys) => {
    if (!pulleys || !pulleys.length) return 0;

    // let total = 0;
    return pulleys.reduce((total, pulley) => total + (pulley.weight ?? 0) * (pulley.numberOfPulley ?? 0), 0);
}
